import { Outlet, useParams } from 'react-router-dom';
import MenuBar from '../components/MenuBar/MenuBar';
import SiteFooter from '../components/SiteFooter/SiteFooter';
import { useSyncHtmlLang } from '../hooks/useSyncHtmlLang';
import styles from './NewspaperLayout.module.css';

export default function NewspaperLayout() {
  const { lang = 'en', city = '' } = useParams<{ lang: string; city: string }>();
  useSyncHtmlLang(lang);

  return (
    <div className={styles.wrapper}>
      <MenuBar lang={lang} city={city} />
      <main className={styles.content}>
        <div className="page-content">
          <Outlet />
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
